import Styles from './MultiPostDetails.module.scss'
import { Button } from 'blaze-ui/Button'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { ArrowRight } from 'blaze-ui/icons'
import { multiStep } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/multiStep'
import { Field } from 'components/Wizards/MobileWizards/Form/Field'
import { Field as BaseField } from 'components/Wizards/MobileWizards/Field/Field'
import { Radio, RadioGroup } from 'components/RadioGroup'
import { useField } from 'formik'
import { PostingCadence } from 'components/Wizards/ContentPlanning/ScheduleContent/ScheduleContent'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import { DatePickerButton } from 'components/Wizards/MobileWizards/Form/DatePickerButton'

export const MultiPostDetails = multiStep(({ schema, submit, getSchemaField }) => {
  const { meta } = schema.describe()
  const postLengthField = getSchemaField('post_length')
  const [{ value: postFrequency }, , { setValue: setPostFrequency }] = useField<PostingCadence>('post_frequency')
  const [{ value: startTime }, , { setValue: setStartTime }] = useField('start_time')
  const [, , { setValue: setIsCustomSchedule }] = useField('is_custom_schedule')

  const POST_FREQUENCY_OPTIONS = {
    [PostingCadence.Once]: 'Once per week',
    [PostingCadence.Twice]: 'Twice per week',
    [PostingCadence.Thrice]: 'Three times per week',
    [PostingCadence.Weekdays]: 'Once every weekday',
    [PostingCadence.Everyday]: 'Once every day',
    [PostingCadence.Custom]: 'Let me pick days',
  }

  const handleFrequencyChange = (newFrequency: string) => {
    setPostFrequency(newFrequency as PostingCadence)
    setIsCustomSchedule(newFrequency === PostingCadence.Custom)
  }

  const handleDateTimeChange = (date: Date | undefined) => {
    setStartTime(date)
  }

  return (
    <>
      <MobileWizard.Content>
        <MobileWizard.Section>
          <MobileWizard.Title>{meta.title}</MobileWizard.Title>
        </MobileWizard.Section>
        {postLengthField && <Field name="post_length" schema={postLengthField} />}
        <BaseField label="What's the start date for the first post?">
          <DatePickerButton
            hideTimePicker={true}
            value={startTime}
            hideTimeDisplay={true}
            onChange={handleDateTimeChange}
            placeholder="Select start date & time"
            allowPastDates={false}
          />
        </BaseField>
        <BaseField label="How frequently do you want Blaze to post?">
          <RadioGroup
            aria-label="Title"
            value={postFrequency}
            className={Styles.radioGroup}
            onChange={handleFrequencyChange}
          >
            {Object.values(PostingCadence).map((cadence, i) => (
              <Radio
                className={Styles.radioOption}
                classNames={{ selected: Styles.selected }}
                value={cadence}
                key={i}
                hideRadio
              >
                {(radioBulletProps) => (
                  <>
                    <div>
                      <RadioBullet {...radioBulletProps} size={20} />
                    </div>
                    <span className={Styles.radioLabel}>{POST_FREQUENCY_OPTIONS[cadence]}</span>
                  </>
                )}
              </Radio>
            ))}
          </RadioGroup>
        </BaseField>
      </MobileWizard.Content>
      <MobileWizard.ButtonFooter>
        <Button size="lg" variant="primary" endIcon={ArrowRight} fullWidth onPress={submit}>
          {postFrequency === PostingCadence.Custom ? 'Select Days' : 'Customize Post Times'}
        </Button>
      </MobileWizard.ButtonFooter>
    </>
  )
})
